import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function ShopifyEcommercePage() {
  return <ServiceDetailLayout slug="shopify-ecommerce" />;
}
